import _ from 'lodash';
import Location from './appsExtendedNamespaces/appsExtendedLocation';
import Site from './appsExtendedNamespaces/appsExtendedSite';
import Window from './appsExtendedNamespaces/appsExtendedWindow';

import monitoring from 'privates/monitoring';

const appsExtendedNamespaces = {
    Location,
    Site,
    Window
};

export default _.mapValues(appsExtendedNamespaces, (namespace) => monitoring.monitorNamespace(namespace));



// WEBPACK FOOTER //
// ./js/modules/appsExtendedNamespaces.es6